import React from 'react';
import PropTypes from 'prop-types';
import { Date as PrismicDate } from 'prismic-reactjs';

import { getShortDateString } from 'dpl/shared/utils/date';

export default function Breadcrumb({ title, path, publicationDate }) {
  const date = PrismicDate(publicationDate);

  return (
    <div className="PrismicBreadcrumb flex f2">
      {title && path && (
        <a href={path} className="fw-medium link--primary">
          {title}
        </a>
      )}
      {title && path && publicationDate && (
        <span className="ml3 mr3">&#124;</span>
      )}
      {publicationDate && <p>{getShortDateString(date, false)}</p>}
    </div>
  );
}

Breadcrumb.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string,
  publicationDate: PropTypes.string
};

Breadcrumb.defaultProps = {
  title: null,
  path: null,
  publicationDate: null
};
